const useStyles = () => {
    return { 
        flex:{
            display: 'flex',
            justifyContent: 'space-between'
        },
        containerInformation: {
            display: 'flex',
            flexDirection:'column', 
            width:'72%', 
        },
    }
}

export { useStyles }
